/**
 * Ashrafie Client Constants
 *
 * Frontend mirrors of backend `AshrafieConfig` defaults. The backend does not
 * yet expose a public `GET /ashrafie/config` endpoint, so these are duplicated
 * here as a temporary contract. If the backend defaults change, update both.
 *
 * TODO: replace with a live `useAshrafieConfig()` hook once the backend exposes
 * /api/v1/ashrafie/config as a public read endpoint.
 *
 * @module lib/api/ashrafie/constants
 */

/**
 * Conversion rate: number of Ashrafie points that equal one penny (1/100th of
 * a currency unit) when redeemed to a campaign. Default 1 means 100 points = $1.
 */
export const ASHRAFIE_CONVERSION_POINTS_PER_PENNY = 1;

/** Minimum points a user can redeem in a single transaction. Backend default: 100n. */
export const ASHRAFIE_MIN_REDEEM_POINTS = 100n;

/** Maximum points a user can redeem in a single transaction. Backend default: 1_000_000n. */
export const ASHRAFIE_MAX_REDEEM_POINTS_PER_TXN = 1_000_000n;

/**
 * Rate limit on POST /redemptions per user per minute. Enforced by the backend
 * at 3 requests/minute -- the frontend uses this to show an elegant cooldown UI
 * before the server would 429.
 */
export const ASHRAFIE_REDEMPTION_RATE_PER_MINUTE = 3;
